(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbc-galleri"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dbc-gallery__lightbox-trigger').forEach(function (card) {
    card.addEventListener('click', function () {
      var lightbox = card.closest('.dbc-gallery').querySelector('.dbc-gallery__lightbox');
      var img = lightbox.querySelector('img');
      img.src = card.getAttribute('data-full');
      img.alt = card.getAttribute('data-cap') || '';
      lightbox.classList.add('is-open');
    });
  });
  document.querySelectorAll('.dbc-gallery__lightbox-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.dbc-gallery__lightbox').classList.remove('is-open');
    });
  });
  document.querySelectorAll('.dbc-gallery__ba-range').forEach(function (range) {
    var wrap = range.closest('.dbc-gallery__ba');
    var after = wrap.querySelector('.dbc-gallery__ba-after');
    var handle = wrap.querySelector('.dbc-gallery__ba-handle');
    range.addEventListener('input', function () {
      after.style.clipPath = 'inset(0 0 0 ' + range.value + '%)';
      handle.style.left = range.value + '%';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
